import { createAsyncThunk } from "@reduxjs/toolkit";

import { formDataPatch, get, patch, post } from "helpers/api_helper";
import {
  API_LOG_DETAILS,
  API_LOGS,
  GET_BANKS_LIST,
  GET_GLOBAL_SETTINGS,
  GET_PAGE_CONTENT,
  GET_SETTINGS_LIST,
  UPDATE_GLOBAL_SETTINGS,
  UPDATE_INTRO_PAGE_DETAILS,
  UPDATE_PAGE_CONTENT,
} from "helpers/url_helper";

export const getGlobalSettings = createAsyncThunk(
  GET_GLOBAL_SETTINGS,
  async () => {
    const response = await get(GET_GLOBAL_SETTINGS);
    return response;
  }
);

export const updateIntroPageDetails = createAsyncThunk(
  UPDATE_INTRO_PAGE_DETAILS,
  async (payload) => {
    const response = await formDataPatch(UPDATE_INTRO_PAGE_DETAILS, payload);
    return response;
  }
);

export const getPageContentByType = createAsyncThunk(
  GET_PAGE_CONTENT,
  async (payload) => {
    const response = await post(GET_PAGE_CONTENT, payload);
    return response;
  }
);

export const updatePageContentByType = createAsyncThunk(
  UPDATE_PAGE_CONTENT,
  async (payload) => {
    const response = await post(UPDATE_PAGE_CONTENT, payload);
    return response;
  }
);

export const updateGlobalSettings = createAsyncThunk(
  UPDATE_GLOBAL_SETTINGS,
  async (payload) => {
    const response = await patch(UPDATE_GLOBAL_SETTINGS, payload);
    return response;
  }
);

export const getSettingsList = createAsyncThunk(GET_SETTINGS_LIST, async () => {
  const response = await get(GET_SETTINGS_LIST);
  return response;
});

export const getBanksList = createAsyncThunk(GET_BANKS_LIST, async () => {
  const response = await get(GET_BANKS_LIST);
  return response;
});

export const getAPILogs = createAsyncThunk(API_LOGS, async (payload) => {
  const response = await post(API_LOGS, payload);
  return response;
});

export const getAPILogDetails = createAsyncThunk(API_LOG_DETAILS, async (id) => {
  const response = await get(`${API_LOG_DETAILS}/${id}`);
  return response;
});
